import React from 'react'
import PropTypes from 'prop-types'
import Clipboard from 'clipboard'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import cssModules from 'react-css-modules'
import styles from './copy_box.less'
import { getI18n } from 'client/i18n'
import FirstChild from 'components/common/first_child'
import { trackClick } from 'lib/fpti_analytics'

const TOOLTIP_ANIMATION_DURATION = 250
const TOOLTIP_SHOW_DELAY = 750

const i18n = getI18n('components/common/copy_box')

class CopyBox extends React.Component {
  static propTypes = {
    text: PropTypes.string.isRequired, // Text to show the user
    copyText: PropTypes.string, // Text to copy to clipboard when user clicks 'copy'. defaults to props.text.
    styles: PropTypes.object,
    enabled: PropTypes.bool,
    charity: PropTypes.object,
  }

  static defaultProps = { enabled: true }

  state = {
    copyText: this.props.copyText || this.props.text,
    showTooltip: false,
  }

  componentDidMount() {
    if (this.props.enabled) {
      const copyText = this.state.copyText
      const copyBoxTextRef = this.copyBoxText
      this.clipboard = new Clipboard(this.copyLink, {
        text() {
          return copyText
        },
        target() {
          return copyBoxTextRef
        },
      })
      this.clipboard.on('success', this.handleCopySuccess)
    }
  }

  componentWillUnmount() {
    if (this.clipboard) {
      this.clipboard.destroy()
    }
  }

  handleCopySuccess = e => {
    this.setState({ showTooltip: true })
    setTimeout(() => {
      this.setState({ showTooltip: false })
    }, TOOLTIP_SHOW_DELAY)
  }

  handleFPTI = () => {
    const { charity } = this.props
    trackClick({
      clickName: 'copy',
      data: {
        event_name: 'dw_giving_share_channel_pressed',
        link_name: 'copy',
        flow:
          charity && charity.name
            ? 'GENEROSITY_NETWORK_CHARITIES'
            : 'GENEROSITY_NETWORK',
        charityname: charity && charity.name,
        crid: charity && charity.nonprofit_id,
      },
    })
  }

  render() {
    const transitionNames = {
      enter: this.props.styles['tooltip-enter'],
      enterActive: this.props.styles['tooltip-enter-active'],
      leave: this.props.styles['tooltip-leave'],
      leaveActive: this.props.styles['tooltip-leave-active'],
    }

    return (
      <div styleName="copy-box-wrapper">
        <div styleName={this.props.enabled ? 'copy-box' : 'copy-box-disabled'}>
          <label htmlFor="share">
            <input
              type="text"
              ref={copyBoxText => {
                this.copyBoxText = copyBoxText
              }}
              value={this.props.text}
              data-nemo="share"
              readOnly={true}
              name="share"
            />
          </label>
          {this.props.enabled && (
            <span styleName="copy-link">
              <a
                data-nemo="copy"
                href="javascript:;"
                onClick={this.handleFPTI}
                ref={copyLink => {
                  this.copyLink = copyLink
                }}
              >
                {i18n('copy')}
              </a>
              <ReactCSSTransitionGroup
                component={FirstChild}
                transitionName={transitionNames}
                transitionEnterTimeout={TOOLTIP_ANIMATION_DURATION}
                transitionLeaveTimeout={TOOLTIP_ANIMATION_DURATION}
              >
                {this.state.showTooltip && (
                  <div styleName="copied-tooltip">{i18n('copied')}</div>
                )}
              </ReactCSSTransitionGroup>
            </span>
          )}
        </div>
      </div>
    )
  }
}

export default cssModules(CopyBox, styles)
